module.exports = __webpack_public_path__ + "static/media/Overview.d030bab2.svg";